import * as React from 'react';

import cn from 'classnames';

export const HelpBlock: React.FC<{
  className?: string;
}> = ({ className, children }) => <div className={cn(className, 'help-block', 'form-text')} children={children} />;
